var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-secondary  btn-sm",attrs:{"type":"button","disabled":!_vm.condition},on:{"click":_vm.click}},[_c('span',{class:_vm.templateArgs.data.icon}),_vm._v(" "+_vm._s(_vm.templateArgs.data.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }